export default async function initializeGtm(gtmId) {
  // Remove existing GTM code if present
  removeExistingGTM();

  // Create and add header script (gtag.js)
  const headerScript = document.createElement("script");
  headerScript.async = true;
  headerScript.src = `https://www.googletagmanager.com/gtag/js?id=${gtmId}`;
  document.head.appendChild(headerScript);

  const headerScriptInline = document.createElement("script");
  headerScriptInline.innerHTML = `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', '${gtmId}');
  `;
  document.head.appendChild(headerScriptInline);

  // Create and add body noscript
  const bodyScript = document.createElement("noscript");
  bodyScript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
  height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.prepend(bodyScript);
}

export function removeExistingGTM() {
  // Remove existing GTM header scripts
  const existingHeaderScripts = document.head.querySelectorAll("script");
  existingHeaderScripts.forEach((script) => {
    if (
      script.innerHTML.includes("googletagmanager.com/gtm.js") ||
      script.innerHTML.includes("dataLayer") ||
      (script.src && script.src.includes("googletagmanager.com/gtag/js"))
    ) {
      script.remove();
    }
  });

  // Remove existing GTM body noscript elements
  const existingBodyScripts = document.body.querySelectorAll("noscript");
  existingBodyScripts.forEach((noscript) => {
    if (noscript.innerHTML.includes("googletagmanager.com/ns.html")) {
      noscript.remove();
    }
  });

  // Clear dataLayer if it exists
  if (window.dataLayer) {
    window.dataLayer = [];
  }
}

